import * as $runtime from "../runtime.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Control$dMonad$dMaybe$dTrans from "../Control.Monad.Maybe.Trans/index.js";
import * as Data$dBigInt from "../Data.BigInt/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dNumber$dFormat from "../Data.Number.Format/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dAff$dClass from "../Effect.Aff.Class/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as TcgCalculator from "../TcgCalculator/index.js";
import * as Worker$dClient from "../Worker.Client/index.js";
const $Query = (_1, _2, _3) => ({tag: "Calculate", _1, _2, _3});
const bindMaybeT = /* #__PURE__ */ Control$dMonad$dMaybe$dTrans.bindMaybeT(Control$dMonad$dFree.freeMonad);
const monadStateMaybeT = /* #__PURE__ */ Control$dMonad$dMaybe$dTrans.monadStateMaybeT(Halogen$dQuery$dHalogenM.monadStateHalogenM);
const $$get = /* #__PURE__ */ (() => monadStateMaybeT.state(s => Data$dTuple.$Tuple(s, s)))();
const guard = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dMaybe$dTrans.alternativeMaybeT(Control$dMonad$dFree.freeMonad);
  const empty = $0.Plus1().empty;
  return v => {
    if (v) { return $0.Applicative0().pure(); }
    return empty;
  };
})();
const liftAff = /* #__PURE__ */ (() => Halogen$dQuery$dHalogenM.monadAffHalogenM(Effect$dAff$dClass.monadAffAff).liftAff)();
const throwError = /* #__PURE__ */ (() => Halogen$dQuery$dHalogenM.monadThrowHalogenM(Effect$dAff.monadThrowAff).throwError)();
const foldMap = /* #__PURE__ */ (() => {
  const mempty = Control$dMonad$dFree.monoidFree(Data$dMonoid.monoidUnit).mempty;
  return v => v1 => {
    if (v1.tag === "Nothing") { return mempty; }
    if (v1.tag === "Just") { return v(v1._1); }
    $runtime.fail();
  };
})();
const pure = /* #__PURE__ */ (() => Control$dMonad$dMaybe$dTrans.applicativeMaybeT(Control$dMonad$dFree.freeMonad).pure)();
const Calculate = value0 => value1 => value2 => $Query(value0, value1, value2);
const component = {
  initialState: v => (
    {deck: {cards: [], others: 0, hand: 0}, condition: [], combination: Data$dBigInt.semiringBigInt.zero, total: Data$dBigInt.semiringBigInt.zero, calculation: Data$dMaybe.Nothing}
  ),
  render: v => Halogen$dVDom$dTypes.$VDom(
    "Elem",
    Data$dMaybe.Nothing,
    "div",
    [Halogen$dHTML$dProperties.class_("flex min-w-60 items-center")],
    [
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "div",
        [Halogen$dHTML$dProperties.class_("mx-1 flex w-36 items-center justify-end gap-1")],
        v.calculation.tag === "Just"
          ? [
              Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "span", [Halogen$dHTML$dProperties.class_("text-2xl")], [Halogen$dVDom$dTypes.$VDom("Text", "Calculating")]),
              Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-spinner fa-pulse")], [])
            ]
          : [
              Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "span",
                [Halogen$dHTML$dProperties.class_("text-2xl")],
                [
                  Halogen$dVDom$dTypes.$VDom(
                    "Text",
                    Data$dBigInt.biEquals(v.total)(Data$dBigInt.semiringBigInt.zero)
                      ? "N/A"
                      : Data$dNumber$dFormat.toStringWith(Data$dNumber$dFormat.$Format("Fixed", Data$dNumber$dFormat.clamp(0)(20)(4)))(100.0 * (
                          Data$dBigInt.toNumber(v.combination) / Data$dBigInt.toNumber(v.total)
                        )) + "%"
                  )
                ]
              )
            ]
      ),
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "div",
        [Halogen$dHTML$dProperties.class_("mx-1 flex min-w-20 justify-end")],
        [
          Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "div",
            [Halogen$dHTML$dProperties.class_("flex flex-col divide-y divide-gray-400")],
            [
              Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "div",
                [Halogen$dHTML$dProperties.class_("px-1 text-right")],
                [Halogen$dVDom$dTypes.$VDom("Text", Data$dBigInt.toString(v.combination))]
              ),
              Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "div",
                [Halogen$dHTML$dProperties.class_("px-1 text-right")],
                [Halogen$dVDom$dTypes.$VDom("Text", Data$dBigInt.toString(v.total))]
              )
            ]
          )
        ]
      )
    ]
  ),
  eval: /* #__PURE__ */ Halogen$dComponent.mkEval({
    ...Halogen$dComponent.defaultEval,
    handleQuery: x => {
      const $0 = x._3;
      const $1 = x._2;
      const deck$p = TcgCalculator.normalizeDeck(x._1)($1);
      return bindMaybeT.bind($$get)(v1 => bindMaybeT.bind(guard(!(
        Data$dEq.eqArrayImpl(ra => rb => ra.count === rb.count && ra.id === rb.id && ra.name === rb.name)(deck$p.cards)(v1.deck.cards) && deck$p.hand === v1.deck.hand && deck$p.others === v1.deck.others
      ) || !Data$dEq.eqArrayImpl(Data$dEq.eqArrayImpl(ra => rb => Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(ra.cards)(rb.cards) && ra.count === rb.count && (() => {
        if (ra.mode === "AtLeast") { return rb.mode === "AtLeast"; }
        if (ra.mode === "JustDraw") { return rb.mode === "JustDraw"; }
        if (ra.mode === "Remains") { return rb.mode === "Remains"; }
        if (ra.mode === "JustRemains") { return rb.mode === "JustRemains"; }
        if (ra.mode === "Choice") { return rb.mode === "Choice"; }
        if (ra.mode === "LeftOne") { return rb.mode === "LeftOne"; }
        return ra.mode === "LeftAll" && rb.mode === "LeftAll";
      })()))($1)(v1.condition)))(() => bindMaybeT.bind(monadStateMaybeT.state(s => Data$dTuple.$Tuple(undefined, {...s, deck: deck$p, condition: $1})))(() => bindMaybeT.bind((() => {
        const $2 = liftAff(Effect$dAff.try(Worker$dClient.run({deck: deck$p, condition: $1})));
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF(
              "Fork",
              (() => {
                const $3 = result => {
                  if (result.tag === "Left") {
                    const $3 = result._1;
                    return Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF(
                          "State",
                          s => Data$dTuple.$Tuple(
                            undefined,
                            {...s, combination: Data$dBigInt.semiringBigInt.zero, total: Data$dBigInt.semiringBigInt.zero, calculation: Data$dMaybe.Nothing}
                          )
                        ),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList("CatCons", () => throwError($3), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil))
                    );
                  }
                  if (result.tag === "Right") {
                    const $3 = result._1;
                    const total = TcgCalculator.calculateTotal(deck$p);
                    return Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, combination: $3, total, calculation: Data$dMaybe.Nothing})),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    );
                  }
                  $runtime.fail();
                };
                return Control$dMonad$dFree.$Free(
                  $2._1,
                  (() => {
                    if ($2._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $3, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                    if ($2._2.tag === "CatCons") {
                      return Data$dCatList.$CatList(
                        "CatCons",
                        $2._2._1,
                        Data$dCatQueue.$CatQueue(
                          $2._2._2._1,
                          Data$dList$dTypes.$List(
                            "Cons",
                            Data$dCatList.$CatList("CatCons", $3, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                            $2._2._2._2
                          )
                        )
                      );
                    }
                    $runtime.fail();
                  })()
                );
              })(),
              Halogen$dQuery$dHalogenM.identity
            ),
            x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            a$p => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", Data$dMaybe.$Maybe("Just", a$p)), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      })())(newCalculation => bindMaybeT.bind(monadStateMaybeT.state(s => Data$dTuple.$Tuple(s.calculation, s)))(currentCalculation => bindMaybeT.bind(monadStateMaybeT.state(s => Data$dTuple.$Tuple(
        undefined,
        {...s, calculation: Data$dMaybe.$Maybe("Just", newCalculation)}
      )))(() => bindMaybeT.bind((() => {
        const $2 = foldMap(Halogen$dQuery$dHalogenM.kill)(currentCalculation);
        return Control$dMonad$dFree.$Free(
          $2._1,
          (() => {
            if ($2._2.tag === "CatNil") {
              return Data$dCatList.$CatList(
                "CatCons",
                a$p => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", Data$dMaybe.$Maybe("Just", a$p)), Data$dCatList.CatNil),
                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
              );
            }
            if ($2._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                $2._2._1,
                Data$dCatQueue.$CatQueue(
                  $2._2._2._1,
                  Data$dList$dTypes.$List(
                    "Cons",
                    Data$dCatList.$CatList(
                      "CatCons",
                      a$p => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", Data$dMaybe.$Maybe("Just", a$p)), Data$dCatList.CatNil),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    ),
                    $2._2._2._2
                  )
                )
              );
            }
            $runtime.fail();
          })()
        );
      })())(() => pure($0))))))));
    }
  })
};
export {$Query, Calculate, bindMaybeT, component, foldMap, $$get as get, guard, liftAff, monadStateMaybeT, pure, throwError};
